import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent {
  @Input() public desc: string = "There is no data to show";
  @Input() public showimg:any = 1;

  constructor(
  ) {
  }

}
